module.exports = __webpack_public_path__ + "img/mystic-miners-1.c5064654.png";